'use strict'
const utility = require('./lib/utility')
module.exports = utility.combineReducers
